export default "__VITE_ASSET__BVGYrGQQ__"